<template>
  <landing-page :style="cssVars" :languageToolbar="false" :backButton="true" class="landingCursor">
    <div class="projectTitleContainer">
      <h2 class="projectTitle_title">
        <strong style="color: white">
          {{ projectTitle }}
        </strong>
      </h2>
    </div>
    <div class="gridContainer">
      <grid></grid>
    </div>
    <div class="userCardContainer">
      <user-card v-if="projectSelected.user" :user="projectSelected.user" :key="projectSelected.user.name"></user-card>
    </div>
    <div class="socialMediaContainer">
      <social-media v-if="projectSelected.metadata" :project="projectSelected" :awards="project.awards"></social-media>
    </div>
    <button class="live-chat-button" @click="callLive()">
    </button>
    <live-chat-modal :project="project" v-if="showLiveChat" @close="callLive"></live-chat-modal>
  </landing-page>
</template>
<script>
import mixin from '../LandingPage/mixin'
import breakpoints from '@/libs/breakpoints'
import LandingPage from '../LandingPage'
import Grid from '../../SectionProjectView/Tabs/Grid'
import state from '../../SectionProjectView/state'
import componentState from '@/mixins/component-state'
import UserCard from '../../SectionProjectView/Header/UserCards/UserCard'
import ProjectCard from '@/components/Cards/ProjectCards'
import SocialMedia from '../../SectionProjectView/Header/SocialMedia'
import auth from '@/mixins/auth'
import contentViewLogMixin from '@/mixins/content-view-log'
import LiveChatModal from '@/components/Modals/Custom/LiveChatModal'
import Vue from 'vue'
import lineClamp from 'vue-line-clamp'
Vue.use(lineClamp, {
  textOverflow: 'ellipsis'
})

export default {
  components: {
    LandingPage,
    Grid,
    UserCard,
    ProjectCard,
    SocialMedia,
    LiveChatModal
  },
  data: function () {
    return {
      project: {},
      projectCode: '',
      projectTitle: '',
      showLiveChat: false
    }
  },
  watch: {
    user: function () {
      this.getBoothInfo()
    }
  },
  mixins: [mixin, LandingPage, componentState, auth, contentViewLogMixin],
  mounted: function () {
    this.getBoothInfo()
  },
  computed: {
    background: function () {
      return 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/backgrounds%2FFinalistBooth-blank.jpg?alt=media&token=a3ab0a74-45a1-4734-9040-fddbc665b138'
    },
    projectId: function () {
      return this._get(state.project.id)
    },
    projectSelected: function () {
      return this.$store.getters.project(this.project.id) ? this.$store.getters.project(this.project.id) : {}
    },
    color: function () {
      return 'white'
    },
    user: function () {
      return this.currentUser
    },
    isMobile: function () {
      return breakpoints.isMobile()
    }
  },
  methods: {
    getBoothInfo: function () {
      this._set(state.activeTab, 'grid')
      this.$store.dispatch('getProject', { id: this.$route.params.id }).then((result) => {
        this.logContentView(result.id, this.$route.name, this.$route.query.utm_source ? this.$route.query.utm_source : '')
        this._set(state.project.id, result.id)
        this.project = result
        this.$router.replace({ path: `/finalist-booth/${result.slug}` }).catch(() => {})
        const params = { id: this.project.id, limit: 6, sort: 'oldest' }
        this.$store.dispatch('getProjectPosts', params).then((result) => {
          this._set(state.comments?.permissions.create, true)
        })
        this.projectTitle = this.project.title
      })
    },
    callLive: function () {
      this.showLiveChat = !this.showLiveChat
    }
  },
  beforeRouteLeave: function (to, from, next) {
    this.project = {}
    this._set(state.project.id, 0)
    next()
  }
}
</script>
<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .projectTitleContainer {
    position: absolute;
    overflow: hidden;
    color: white;
    letter-spacing: 1px;
    top: 9.7%;
    left: 23%;
    height: 7.9%;
    width: 54%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    padding: 0.5rem;
    @media only screen and (max-width: 926px) and (orientation : landscape) {
      padding: 0.5rem
    }
    padding: 0 1rem;

    @media only screen
    and (max-height: 430px)
    and (orientation: landscape) {
      width: 60%;
      margin-left: -1rem;
    }

    // Overriding Bulma h2
    h2 {
      font-size: 1.2em !important;
      @media(max-height: 700px) {
        font-size: 1em !important;
      }
      @media(max-height: 500px) {
        font-size: 0.8em !important;
      }
      @media (max-height: 430px)
      and (orientation: landscape) {
        font-size: .6em !important;
        width: 80% !important;
      }
    }
    &_title {
      font-family: BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif;
      width: 100%;
      max-height: 100%;
      color: white;
      font-weight: bold;
      margin-bottom: 0.5rem;
      font-family: BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif;
      @media only screen and (max-width: 926px) and (orientation : landscape) {
        font-size: .7em;
      }
      @media(max-height: 700px) {
        font-size: 1rem;
      }
      @media(max-height: 500px) {
        font-size: 0.8rem;
      }
    }
  }
  .gridContainer {
    width: 35%;
    height: 40%;
    position: absolute;
    top: 15%;
    left: 31%;
  }
// grid component css
  ::v-deep .gridcolumn {
    width: 33.33% !important;
    height: 50% !important;
    .image {
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
    @include mobile {
      padding: 0.5rem !important;
    }
  }
  ::v-deep .postGrid, ::v-deep .backColor, ::v-deep .gridcolumns, ::v-deep .infiniteContainer, ::v-deep .no-reorder, ::v-deep .grid-area, ::v-deep .backColor, ::v-deep .gridTab {
    height: 100% !important;
  }
  ::v-deep .sort {
    display: none !important;
  }
  ::v-deep .gridcolumns{
    background-color: transparent;
  }
  .content:hover {
    background-color: transparent !important;
    box-shadow: 0px 5px 15px -1px white !important;
  }
  ::v-deep .gridcolumnitem:nth-of-type(4) {
    position: absolute;
    top: 15.5% !important;
    left: 14% !important;
    width: 38.6% !important;
    height: 46.5% !important;
  }
  ::v-deep .gridcolumnitem:nth-of-type(2) {
    position: absolute;
    left: 54.2% !important;
    width: 40.5% !important;
    height: 34.5% !important;
    bottom: 39%;
  }
  ::v-deep .gridcolumnitem:nth-of-type(5) {
    position: absolute;
    top: 80.4% !important;
    right: 52.3% !important;
    width: 50.5% !important;
    height: 37% !important;
  }
  ::v-deep .gridcolumnitem:nth-of-type(1) {
    position: absolute;
    top: 7% !important;
    width: 39.1% !important;
    height: 74.2% !important;
    right: 86%;
  }
  ::v-deep .gridcolumnitem:nth-of-type(3) {
    display: none;
  }
  // usercard component
  .userCardContainer {
    position: absolute;
    left: 64.3%;
    top: 19%;
    width: 12.8%;
    height: 31.3%;
  }
  ::v-deep .user-card {
    display: block !important;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
    padding-top: 0.25rem !important;
    width: 100% !important;
    height: 100% !important;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    border-radius: 5px;
  }
  //social engagement
  ::v-deep .engagement-wrapper {
    top: 12% !important;
    left: 2% !important;
    position: absolute;
  }
  .view-board {
    display: block;
    position: absolute;
    left: 5%;
    top: 5%;
    cursor: pointer;
    z-index: 20;
    .button {
      padding: 0.25rem 0.5rem;
      font-size: 0.8rem;
      background: linear-gradient(45deg, #713cd3, #6639B7) !important;
      cursor: pointer;
    }
  }
  ::v-deep .engagement-wrapper {
    background-color: rgba(242, 242, 242, 0.952) !important;
    border-radius: 11px !important;
  }
  ::v-deep .engagement-container {
    margin: 0 !important;
  }
  ::v-deep .milieu {
    width: 100% !important;
  }
  ::v-deep .socialContainer {
    width: 100% !important;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-direction: column;
  }
  .live-chat-button {
    position: absolute;
    top: 55%;
    right: 30%;
    width: 23%;
    height: 7%;
    background-color: transparent;
    border: none;
    cursor: pointer;
  }
 //.go css is to create the clickable areas in landing page
  @media only screen and (max-width: 1023px) {
    .view-board{
    top: 9% !important;
    left: 1% !important;
    }
    ::v-deep .engagement-container {
      width: 90% !important;
    }
    ::v-deep .milieu {
      width: auto !important;
    }
    ::v-deep .socialMediaContainer .engagement-wrapper {
     width: 93% !important;
     top: 0 !important;
    }
  }
  @media only screen and (max-height: 900px) {
    .follow-button {
      margin-top: 0.5rem;
    }
  }
  @media only screen and (max-height: 800px) {
    ::v-deep .engagement-container {
    margin: 0 !important;
  }
}

  .social-media {
    top: 90px;
  }
  @media only screen and (max-width: 1023px) {
  .social-media {
    top: 0px;
  }
}
  h2 {
    margin: 0 !important;
  }
  @media only screen and (max-height: 775px) {
    ::v-deep .bio {
      display: none !important;
    }
  }
</style>
